/* Barra sticky de add-to-cart (mobile) — ver snippets/sticky-atc.liquid.
   Mostra a barra quando o botão de compra real sai da viewport pelo topo;
   o clique delega para o submit original do form do produto. */
(function () {
  function init() {
    document.querySelectorAll('.sticky-atc').forEach(function (bar) {
      if (bar.dataset.stickyAtcReady) return;
      bar.dataset.stickyAtcReady = 'true';

      var sectionId = bar.dataset.sectionId;
      var submit = document.getElementById('ProductSubmitButton-' + sectionId);
      var barBtn = bar.querySelector('.sticky-atc__btn');
      var variantAvailable = bar.dataset.available === 'true';
      if (!submit || !barBtn) return;

      barBtn.addEventListener('click', function () {
        if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
        submit.click();
      });

      if (!('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', passed);
            bar.style.display = 'flex';
            bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
            if (passed) {
              bar.removeAttribute('inert');
              barBtn.disabled = !variantAvailable || submit.disabled || submit.getAttribute('aria-disabled') === 'true';
            } else {
              bar.setAttribute('inert', '');
              barBtn.disabled = true;
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(submit);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
